<template>
  <div id="app">
    <div class="timer-box">
      <div
        class="container"
        id="container"
        v-bind:class="{ grow: doGrow && start, shrink: !doGrow && start }"
      >
        <div class="circle"></div>

        <p id="text">{{ text }}</p>

        <div
          class="pointer-container"
          v-bind:class="{ 'pointer-animation': start }"
        >
          <span class="pointer"></span>
        </div>

        <div class="gradient-circle"></div>
      </div>

      <footer>
        <a href="https://mindfuldevmag.com/" target="_blank">
          <img
            src="@/assets/logo-white-small-space.png"
            alt="mindfuldevmag logo"
          />
        </a>
        &rarr;
        <a href="https://mindfuldevmag.com/products" target="_blank"
          >More Tools</a
        >&nbsp;
        <br />
        <small>
          <a href="/impressum" target="_blank" rel="nofollow">Imprint</a> -
          <a href="/datenschutz" target="_blank" rel="nofollow"
            >Privacy Policy</a
          >
        </small>
      </footer>
    </div>

    <sidebar
      text="Heart Rate Variability (HRV) breathing with 5 breath per minute."
      showAnimationList="false"
    />
  </div>
</template>

<script>
import sidebar from "@/components/sidebar.vue";
export default {
  name: "App",
  components: { sidebar },
  data: function () {
    return {
      text: null,
      breathCycleLength: 12000, //ms
      doGrow: false,
      start: false,
    };
  },
  computed: {
    breatheInTime: function () {
      return 6000;
    },
    breatheOutTime: function () {
      return 6000;
    },
  },
  mounted: function () {
    this.breathAnimation();
    setInterval(this.breathAnimation, this.breathCycleLength);
  },
  methods: {
    breathAnimation: function () {
      this.start = true;
      this.text = "Breathe In";
      this.doGrow = true;
      var self = this;
      setTimeout(() => {
        self.text = "Breathe Out";
        this.doGrow = false;
      }, this.breatheInTime);
    },
  },
};
</script>

<style>
/* nunito-regular - latin */
@font-face {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.eot");
  /* IE9 Compat Modes */
  src: local("Nunito Regular"), local("Nunito-Regular"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}

/* nunito-italic - latin */
@font-face {
  font-family: "Nunito";
  font-style: italic;
  font-weight: 400;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.eot");
  /* IE9 Compat Modes */
  src: local("Nunito Italic"), local("Nunito-Italic"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}

/* nunito-700 - latin */
@font-face {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.eot");
  /* IE9 Compat Modes */
  src: local("Nunito Bold"), local("Nunito-Bold"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}

/* nunito-700italic - latin */
@font-face {
  font-family: "Nunito";
  font-style: italic;
  font-weight: 700;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.eot");
  /* IE9 Compat Modes */
  src: local("Nunito Bold Italic"), local("Nunito-BoldItalic"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}

@font-face {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.eot");
  /* IE9 Compat Modes */
  src: local("Nunito SemiBold"), local("Nunito-SemiBold"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}
* {
  box-sizing: border-box;
}

body {
  background: #464646;
  color: #dcdccc;
  font-family: "Nunito", sans-serif;
  margin: 0;
}
.timer-box {
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
}

footer {
  padding: 10px;
  text-align: center;
  vertical-align: middle;
}
footer img {
  height: 40px;
  vertical-align: middle;
}

footer a,
footer small {
  color: #dcdccc;
}
a {
  color: #8faf9f;
  cursor: pointer;
}
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  height: 240px;
  width: 240px;
  position: relative;
  transform: scale(1);
}

.circle {
  background-color: #464646;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.gradient-circle {
  background: conic-gradient(
    #dcdccc 0%,
    #dcdccc 50%,
    #8faf9f 50%,
    #8faf9f 100%
  );
  height: 260px;
  width: 260px;
  z-index: -2;
  border-radius: 50%;
  position: absolute;
  top: -10px;
  left: -10px;
}

.pointer {
  background-color: #dca3a3;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  display: block;
}

.pointer-container {
  position: absolute;
  top: -30px;
  left: 110px;
  width: 20px;
  height: 150px;
  transform-origin: bottom center;
}
@media only screen and (max-width: 350px) {
  footer img {
    height: 70%;
    vertical-align: middle;
  }
  .container {
    height: 200px !important;
    width: 200px !important;
  }

  .gradient-circle {
    height: 220px;
    width: 220px;
    top: -10px;
    left: -10px;
  }

  .pointer-container {
    position: absolute;
    top: -30px;
    left: 90px;
    width: 20px;
    height: 130px;
    transform-origin: bottom center;
  }
}

.pointer-animation {
  animation: rotate 12s linear forwards infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.container.grow {
  animation: grow 6s linear forwards;
}

@keyframes grow {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(1.2);
  }
}

.container.shrink {
  animation: shrink 6s linear forwards;
}

@keyframes shrink {
  from {
    transform: scale(1.2);
  }

  to {
    transform: scale(1);
  }
}

#text {
  font-weight: 700;
  font-size: 24px !important;
}
</style>
